<template>
  <div>
    <div class="md-layout md-size-100 md-small-size-100">
      <StatCardWithIcon
        v-for="card in this.singleInfoCard"
        @emit="emit"
        :appIds="card.id_array"
        :title="card.title"
        :value="card.value"
        :icon="card.icon"
        :color="card.color"
        :key="card.title"
        :filter="card.filter"
        :footer="card.footer"
        :percChangeData="card.perc_change_data"
        ableToViewApp
      />
      <SplitStatCardWithIcon
        v-for="card in this.splitInfoCard"
        :title="card.title"
        :title-ext="card.titleExt"
        :value="card.value"
        :value-ext="card.valueExt"
        :icon="card.icon"
        :color="card.color"
        :key="card.title"
        :filter="card.filter"
        :footer="card.footer"
      >
      </SplitStatCardWithIcon>
       <!-- Cards Slot: Additional cards can be passed here from the parent component -->
      <slot name="cards-slot"></slot>
    </div>
    <div class="md-layout md-size-full md-small-size-100">
      <FunnelStatCard
        v-for="card in this.funnelInfoCard"
        @emit="emit"
        :title="card.title"
        :value="card.value"
        :csvData="Object.values(card.csv_data)"
        :icon="card.icon"
        :color="card.color"
        :key="card.title"
        :filter="card.filter"
        ableToViewApp
      />
    </div>

    <div
      class="md-layout md-size-100 md-small-size-100 boxed-category"
      v-if="(this.filters.dropdown.pod || this.filters.dropdown.broker) && this.pipelineTabGraph.statusApplication"
    >
      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.pipelineTabGraph.statusApplication">
        <md-subheader>Application Status Count</md-subheader>
        <div v-if="this.pipelineTabGraph.statusApplication ? !this.pipelineTabGraph.statusApplication.showChart : true" >
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <bar-chart v-else :chart-options="graphOption" :chart-data="this.pipelineTabGraph.statusApplication" :height="350"/>
      </div>

      <!-- Auctions Leads CHART -->
      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.pipelineTabGraph.podBasedAuctionsStat">
        <md-subheader>Auctions Leads</md-subheader>
        <div v-if="this.pipelineTabGraph.podBasedAuctionsStat ? !this.pipelineTabGraph.podBasedAuctionsStat.showChart : true" >
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <bar-chart v-else :chart-options="twoValuesInOneBar" :chart-data="this.pipelineTabGraph.podBasedAuctionsStat" :height="150"/>
      </div>

      <!-- LEAD CONVERSION CHART -->
      <div class="md-layout-item md-size-100 md-small-size-100 graph-boxed" v-if="this.pipelineTabGraph.leadConversion">
        <md-subheader>Lead Conversion</md-subheader>
        <div v-if="this.pipelineTabGraph.leadConversion ? !this.pipelineTabGraph.leadConversion.showChart : true" >
          <notification-card message="Not enough data to render the chart" icon="error" type="warning"></notification-card>
        </div>
        <line-chart v-else :chart-options="graphOption" :chart-data="this.pipelineTabGraph.leadConversion" :height="350"/>
      </div>
    </div>
  </div>
</template>

<script>
import FunnelStatCard from "./ReportingDashboard/components/FunnelStatCard";
import StatCardWithIcon from "./ReportingDashboard/components/StatCardWithIcon";
import BarChart from "./ReportingDashboard/charts/BarChart";
import LineChart from "./ReportingDashboard/charts/LineChart";
import NotificationCard from "../components/Cards/NotificationCard";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import SplitStatCardWithIcon from "./ReportingDashboard/components/SplitStatCardWithIcon";

export default {
  components: {
    StatCardWithIcon,
    SplitStatCardWithIcon,
    BarChart,
    NotificationCard,
    LineChart,
    LoadingIconTextButton,
    FunnelStatCard
  },
  props: ['pipelineTabStats','pipelineTabGraph','filters'],
  data() {
    return {
      graphOption: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            color: 'black',
            backgroundColor: 'white',
            textAlign: 'center',
            borderRadius: 5,
          }
        },
      },
      twoValuesInOneBar: {
        scales: {
          xAxes: [{
            stacked: true // Enables stacking on the x-axis
          }],
          yAxes: [{
            stacked: true // Enables stacking on the y-axis
          }]
        }
      },
    }
  },
  computed: {
    singleInfoCard() {
      const data = this.pipelineTabStats.filter(function(element) {
          return element.title !== 'MQL Conversion'
        });
        return data;
    },
    splitInfoCard() {
      const data = this.pipelineTabStats.filter(function(element) {
          return element.title == 'MQL Conversion'
        });
      return data;
    },
    funnelInfoCard() {
      const data = this.pipelineTabStats.filter(function(element) {
          return element.is_funnel
        });
      return data;
    }
  },
  methods: {
    emit(data) {
      this.$emit('show',data);
    }
  },
  created() {
  }
}

</script>
<style scoped lang="scss">
</style>
